import {Component, Input, NgModule, OnInit} from '@angular/core';
import {SubmissionSearchUserInfoObject} from '../../search-object';
import {Subscription} from 'rxjs';
import {SubmissionHistoryService} from '../../../../shared/services/submission-history.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { colorScheme } from './kpi-color-scheme';

@Component({
  selector: 'kpi-bar-chart',
  templateUrl: './kpi-bar-chart.component.html',
  styleUrls: ['./kpi-bar-chart.component.scss']
})
export class KpiBarChartComponent implements OnInit {

    @Input() userInfo: any;
    @Input() data: any;
    @Input() xAxisLabel: string;
    @Input() yAxisLabel: string;
    @Input() graphTitle: any;

    // options
    colorScheme: any[];
    view: any[] = [500, 300];
    legend = false;
    gradient = true;
    showLabels = true;
    animations = true;
    xAxis = true;
    yAxis = true;
    showYAxisLabel = true;
    showXAxisLabel = true;
    timeline = true;

    constructor(private submissionHistoryService: SubmissionHistoryService) {
        Object.assign(this, { colorScheme })
    }

    ngOnInit() {
   }

    public getKpiInfo() {

    }

    onSelect(data): void {
        console.log('Item clicked', JSON.parse(JSON.stringify(data)));
    }

    onActivate(data): void {
        console.log('Activate', JSON.parse(JSON.stringify(data)));
    }

    onDeactivate(data): void {
        console.log('Deactivate', JSON.parse(JSON.stringify(data)));
    }

}
